export default __webpack_public_path__ + "static/media/shield-lock-outline.985273d9.svg";